






























































































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';

import {Notify} from '@/utils/Notify';

import SystemInfoStore from '@/store/system/SystemInfo.store';
import SystemUpdateStore from '@/store/system/SystemUpdate.store';
import SystemUpgradeStore from '@/store/system/SystemUpgrade.store';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({})
export default class SystemUpdateChecker extends Mixins<BaseComponent>(BaseComponent) {
  private systemInfoStore: SystemInfoStore = getModule(SystemInfoStore, this.$store);

  private systemUpgradeStore: SystemUpgradeStore = getModule(SystemUpgradeStore, this.$store);

  private systemUpdateStore: SystemUpdateStore = getModule(SystemUpdateStore, this.$store);

  private checkError = false;

  private channel: string | null = null;

  private channels = [
    {id: 'stable', label: 'Stable'},
    {id: 'lts', label: 'Long term support'},
    {id: 'latest', label: 'Latest'},
  ];

  private async mounted() {
    await this.systemUpgradeStore.fetchChannel();

    this.channel = this.systemUpgradeStore.Channel;

    await this.checkUpdateAvailable();
  }

  private async checkUpdateAvailable() {
    try {
      this.setLoading();

      await this.systemInfoStore.fetchOsInfo();
      await this.systemInfoStore.fetchHardwareInfo();
      await this.systemUpgradeStore.fetchRepository();

      if (!this.systemInfoStore.HardwareInfo || !this.systemInfoStore.OsInfo || !this.channel) {
        throw new Error('No OS or channel info');
      }

      await this.systemUpdateStore.checkUpdateAvailable({
        osInfo: this.systemInfoStore.OsInfo,
        repository: this.systemUpgradeStore.Repository,
        channel: this.channel,
      });

      this.checkError = false;

    } catch (error) {
      Notify.Error(this.logger, `Could not check available update`, error);
      this.checkError = true;
    } finally {
      this.setLoaded();
    }
  }

  private showFile(url: string) {
    window.open(url);
  }

  get alertType(): string {
    if (this.checkError) {
      return 'error';
    }

    if (this.systemUpdateStore.UpdateAvailable) {
      return 'info';
    } else {
      return 'success';
    }
  }
}
